<template>
  <v-btn
    :outlined="outline"
    :color="color"
    :depressed="depressed"
    :text="flat"
    :class="[buttonClass, 'round-button']"
    :dark="dark"
    :height="height"
    :min-width="width"
    :width="width"
    :style="buttonProps"
    :disabled="disabled"
    :loading='this.currentLoading'
    :to="to"
    @click="sendClicked">
    <v-icon
      :size="iconSize"
      :color="iconColor"
      v-if="icon"
      :class="buttonText ? 'mr-1' : ''">
      {{ iconText }}
    </v-icon>
    <span
      :class="[capitalize ? 'capitalize' : '', disabled ? 'text--white': '']"> <!--capitalize means pascal case. Default is upper-->
      {{ buttonText }}
    </span>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  inheritAttrs: false,
  props: [
    'roundness',
    'outline',
    'color',
    'width',
    'height',
    'depressed',
    'flat',
    'buttonText',
    'buttonTextColor',
    'buttonClass',
    'icon',
    'iconText',
    'iconColor',
    'iconSize',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'dark',
    'disabled',
    'capitalize',
    'fontSize',
    'to'
  ],
  data () {
    return {
    }
  },
  methods: {
    sendClicked () {
      if (!this.currentLoading) {
        this.$emit('click')
      }
    }
  },
  computed: {
    ...mapGetters(['currentLoading']),
    buttonProps () {
      return {
        '--background-color': !this.disabled && !this.currentLoading ? this.backgroundColor : '#d1d1d1',
        '--border-color': !this.disabled && !this.currentLoading ? this.borderColor : '#d1d1d1',
        '--border-radius': this.roundness === undefined ? '10px' : this.roundness,
        '--text-color': this.buttonTextColor === undefined || this.disabled ? 'white' : this.buttonTextColor,
        '--font-size': this.fontSize === undefined ? '12px' : this.fontSize,
        '--border-width': this.borderWidth === undefined ? '1px' : this.borderWidth
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.round-button {
  background-color: var(--background-color) !important;
  border-color: var(--border-color) !important;
  border-radius: var(--border-radius);
  border-width: var(--border-width);
  span {
    font-size: var(--font-size);
    color: var(--text-color) !important;
    font-family: roboto;
    letter-spacing: 0em;
  }

  .capitalize {
    text-transform: capitalize !important;
  }

  .round-button::v-deep .v-btn:before {
      background-color: var(--background-color) !important;
  }
}
</style>
